import { AxiosHelper } from "../axiosConfig";
import APIConstant from "../utils/apiConstant";
import {
  ILiftOffDiagnosticTestQuestion,
  IQuestionExistsRequest,
  IStandardExistsRequest,
} from "../model/interface/liftOffDiagnosticTest";

export const getLFDiagnosticTestQuestion = (
  lfDiagnosticTestId: number,
  lfHeaderId: number,
  pageNumber: number,
  pageSize: number
) => {
  return AxiosHelper.axiosInstance().get(
    `${APIConstant.CMS_LIFTOFFDIAGNOSTICTESTQUESTION}`,
    {
      params: {
        liftOffDiagnosticTestID: lfDiagnosticTestId,
        liftOffHeaderId: lfHeaderId,
        pageNumber: pageNumber,
        pageSize: pageSize,
      },
    }
  );
};

export const deleteLFDiagnosticTestQuestion = (
  lfDiagTestQuestionId: number,
  userId: number
) => {
  return AxiosHelper.axiosInstance().delete(
    `${APIConstant.CMS_LIFTOFFDIAGNOSTICTESTQUESTION}`,
    {
      params: {
        liftoffDiagTestQuestionId: lfDiagTestQuestionId,
        userId: userId,
      },
    }
  );
};

export const updateLFDiagnosticTestQuestion = (
  liftoffDiagnosticTestQuestions: Array<ILiftOffDiagnosticTestQuestion>
) => {
  return AxiosHelper.axiosInstance().put(
    `${APIConstant.CMS_LIFTOFFDIAGNOSTICTESTQUESTION}`,
    { liftoffDiagnosticTestQuestions },
    {}
  );
};

export const checkQuestionExists = (request: IQuestionExistsRequest) => {
  return AxiosHelper.axiosInstance().get(
    `${APIConstant.CMS_LIFTOFFDIAGNOSTICTESTQUESTION + "/IsQuestionExists"}`,
    {
      params: {
        LiftOffDiagnosticTestId: request.liftOffDiagnosticTestId,
        StandardReferenceId: request.standardReferenceId,
        GradeId: request.gradeId,
        QuestionId1: request.questionId1,
        QuestionId2: request.questionId2,
        IsStandardGroup: request.isStandardGroup,
      },
    }
  );
};

export const checkStandardExists = (request: IStandardExistsRequest) => {
  return AxiosHelper.axiosInstance().get(
    `${APIConstant.CMS_LIFTOFFDIAGNOSTICTESTQUESTION + "/IsStandardExists"}`,
    {
      params: {
        LiftOffDiagnosticTestId: request.liftOffDiagnosticTestId,
        StandardReferenceId: request.standardReferenceId,
        SubjectId: request.subjectId,
      },
    }
  );
};
